import { useRouter } from "next/router";
import { withApolloSSR } from "@/shared/utils/withApolloSSR";
import { VideoScreen } from "@/widgets/VideoScreen";

// Полная страница видео — только для прямых заходов (SEO, шаринг, F5).
// Клики по ссылкам на /video/... на этот роут вообще не попадают: они меняют
// URL сырой записью в историю мимо Next-роутера (см. openRouteDialog), а
// VideoScreen рендерится в route-диалоге поверх текущей страницы (_app).
const VideoPage = () => {
  const router = useRouter();
  const id = router.query.id as string;
  // Плейлист-контекст коллекции при прямом заходе (?collectionId=)
  const collectionId =
    typeof router.query.collectionId === "string"
      ? router.query.collectionId
      : undefined;

  return <VideoScreen id={id} collectionId={collectionId} />;
};

export const getServerSideProps = withApolloSSR(VideoPage);
export default VideoPage;
